{
	"add": "Ajouter un produit",
	"addItem": "Ajouter un article",
	"addItemName": "Article {{length}}",
	"average": "Moyenne",
	"category": "Catégorie",
	"categoryPlaceholder": "Catégorie de produits",
	"description": "Description",
	"descriptionPlaceholder": "Description produit",
	"edit": "Modifier Produit",
	"equivalentProduct": "Produit équivalent",
	"higher": "Plus haut",
	"max": "Max",
	"maxCount": "Qté maximale sélectionnable",
	"min": "Min",
	"mountableProduct": "Produit combinable",
	"name": "Nom",
	"namePlaceholder": "Nom du produit",
	"noCategory": "Sans catégorie",
	"price": "Prix",
	"pricing": "Tarification",
	"product": "Produit",
	"productPrice": "Prix du produit",
	"save": "Sauvegarder les modificatons",
	"searchProduct": "Rechercher par produits",
	"sku": "SKU",
	"step": "Étape {{index}}",
	"sum": "Somme",
	"title": "Titre",
	"titlePlaceholder": "Titre de l'étape",
	"validadeField": "Champ obligatoire",
	"zigCategory": "Catégorie ZIG"
}
